import "src/stylesheets/jobs/applications/new.scss"
import "src/javascripts/jobs/applications/new.js"
import "src/javascripts/jobs/applications/shared/address_form.js"
